require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-json-apis-and-ajax-pre-filter-json-to-get-the-data-you-need.json") })
        }
      }, "path---data-visualization-json-apis-and-ajax-pre-filter-json-to-get-the-data-you-need");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-json-apis-and-ajax-pre-filter-json-to-get-the-data-you-need!./.cache/json/data-visualization-json-apis-and-ajax-pre-filter-json-to-get-the-data-you-need.json
// module id = 1982
// module chunks = 231608221292675